import { useEffect, useMemo, useRef, useState } from 'react';
import styles from './index.less';
import closeSvg from '@/assets/icon/close.svg';

interface IProps{
    onClose: Function,
}

const LoginHoldPopup = ({onClose} : IProps) => (<div className={`${styles.holdMask} ${styles.openDialog}`}>
    <div className={`${styles.holdWapper} ${styles.container}`}>
        <img onClick={() => onClose(0)} className={styles.img} src='https://cdn2.weimob.com/saas/saas-fe-sirius-orion-node/production/zh-CN/483/ercilanjiedanchuang@3x.png'/>
        <div className={styles.close} onClick={() => onClose(1)}><img src={closeSvg} /></div>
    </div>
</div>);

export default LoginHoldPopup;